import { node, oneOf } from "prop-types";

import { fontWeightOptions } from "../constants/fontWeightOptions";
import * as S from "./styled";

const PrimaryLarge = S.PrimaryLargeBase;

PrimaryLarge.displayName = "PrimaryLarge";

PrimaryLarge.propTypes = {
  children: node.isRequired,
  weight: oneOf([fontWeightOptions.LIGHT, fontWeightOptions.SEMI_BOLD])
};

PrimaryLarge.defaultProps = {
  weight: fontWeightOptions.LIGHT
};

export default PrimaryLarge;
